import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import app from './app'
import orgstructure from './orgstructure'
import auth from '@/apps/auth/store'

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    auth,
    app,
    orgstructure
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js